import { CatalogIndexPage } from '@backstage/plugin-catalog';
import { EntityRefLink } from '@backstage/plugin-catalog-react';
import { OverflowTooltip } from '@backstage/core-components';

import {
  EntityKindPicker,
  EntityTypePicker,
  UserListPicker,
} from '@backstage/plugin-catalog-react';

export const Teams = () => {
  return (
    <CatalogIndexPage
      filters={
        <>
          <EntityKindPicker initialFilter="Group" allowedKinds={['Group']} />
          <EntityTypePicker initialFilter="team" />
          <UserListPicker initialFilter="all" />
        </>
      }
      tableOptions={{ draggable: false, thirdSortClick: false }}
      columns={[
        {
          title: 'Name',
          field: 'entity.spec.profile.displayName',
          highlight: true,
          defaultSort: 'asc',
          render: ({ entity }) => (
            <EntityRefLink entityRef={entity} defaultKind="Group" />
          ),
        },
        {
          title: 'Type',
          field: 'entity.spec.type',
          sorting: false,
        },
        {
          title: 'Description',
          field: 'entity.metadata.description',
          sorting: false,
          render: ({ entity }) => (
            <OverflowTooltip
              text={entity.metadata.description}
              placement="bottom-start"
            />
          ),
        },
      ]}
    />
  );
};
